import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ToggleCollapsedAsync } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/NodeBullet/ToggleCollapsedAsync/ToggleCollapsedAsync";

export function NodeBullet({
    node, index,
}: {
    node: IWorkflowNode;
    index: number;
}) {
    const modValue = index % 2;

    const [isChanging, setIsChanging] = React.useState<boolean>(false);

    const background = isChanging
        ? `white`
        : modValue === 0
            ? `#4e4a4a`
            : `#6a6a6a`;

    return (
        <div
            className={StyleClass(`nodeBulletBackground_${background}`, {
                background,
                minHeight: `20px`,
                borderRadius: `3px`,
            })}
            onClick={async () => {
                setIsChanging(true);
                await ToggleCollapsedAsync(node);
                setIsChanging(false);
            }}
        >
        </div>
    );
}
